import { ConfigService } from './../../services/config.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EventModel } from '../../models/event-model.model';
import { EventService } from '../../services/event.service';
import { CameraService } from '../../services/camera.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { User } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-event-edit',
  templateUrl: './event-edit.component.html',
  styleUrls: ['./event-edit.component.css']
})
export class EventEditComponent implements OnInit {

  public uploader: FileUploader = new FileUploader({
    url: `http://${window.location.hostname}:3000/api/v1/events/image`,
    autoUpload: false,
    authToken: `Bearer ${User.getTokenFromLS()}`,
    method: 'post'
  });
  public fbAuthNumber = null;
  @ViewChild('modal') protected modal: ElementRef;

  public availableCameras = [];
  public selectedCamera = [];

  public availableConfigs = [];
  public selectedConfig = [];

  public isEdit = false;
  public imageBasePath = `http://${window.location.hostname}:3000`

  public event = new EventModel({
    server_url: 'rtmp://live-api-a.facebook.com:80/rtmp',
    start_date: moment().toISOString(),
    end_date: moment().add(1, 'hour').toISOString(),
  });
  public errors: any = {};
  constructor(
    private router: Router,
    protected route: ActivatedRoute,
    protected eventService: EventService,
    protected cameraService: CameraService,
    protected configService: ConfigService,
    protected authService: AuthService,
    protected modalService: NgbModal
  ) {
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
  }

  ngOnInit() {
    this.route.params.subscribe(route => {
      this.cameraService.index().subscribe(cameras => {
        this.availableCameras = cameras;

        if (route['_id']) {
          this.isEdit = true;
          this.eventService.show(route['_id']).subscribe(event => {
            this.event = event;
            this.selectedCamera[0] = this.event.camera._id;
            this.cameraSeleted();
            this.configService.show(event.config._id).subscribe(config => {
              this.selectedConfig = [config._id]
              this.configSelected()
            })
          });
        }

        this.configService.index().subscribe(configs => {
          this.availableConfigs = configs;
        });

      });
    });
  }

  cameraSeleted() {
    this.event.camera = this.availableCameras.find(camera => camera.id === this.selectedCamera[0]);
  }

  configSelected() {
    this.event.config = this.availableConfigs.find(config => config._id == this.selectedConfig[0]);
  }

  submit() {
    this.authService.checkFBToken().subscribe((fb_token_exist) => {
      if (!fb_token_exist) {
        this.authService.getFBAuthNumber().subscribe((number) => {
          this.fbAuthNumber = number;
          const modal = this.modalService.open(this.modal, {
            keyboard: false,
            backdrop: 'static'
          });

          this.authService.waitForFBAuth().subscribe((res) => {
            modal.close();
            if (res === true) {
              this.save();
            }
          });
        });
      } else {
        this.save();
      }
    });
  }

  save() {
    this.eventService.updateOrStore(this.event, this.isEdit).subscribe(result => {
      // TODO: find out better way to add event information to the fileupload api
      if (this.uploader.queue.length > 0) {
        this.uploader.queue[0].url += `?event=${ result._id }`
      }
      this.uploader.uploadAll()
      return this.router.navigate(['/events']);
    }, errors => {
      this.errors = errors;
      console.log(errors);
    });
  }

  // fileChangeEvent(fileInput: any) {
  //   if (fileInput.target.files && fileInput.target.files[0]) {
  //
  //   }
  // }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/event-edit/event-edit.component.ts